import { Outlet } from "react-router-dom";

export function AppSettingsLayout() {
  return <Outlet />;
}
